import {
  getAllPositionSchedulingRulesService,
  getPositionSchedulingRuleByIdService,
  createPositionSchedulingRuleService,
  updatePositionSchedulingRuleService,
  deletePositionSchedulingRuleService,
  restorePositionSchedulingRuleService,
} from '../../services/positionSchedulingRules.service';
import { checkingPreload, unCheckingPreload } from '../loading';
import {
  setPositionSchedulingRules,
  setPositionSchedulingRule,
  setPositionForSelect,
  setGlobalRules,
} from './slice';
// import { checkingPreload, unCheckingPreload } from '../preloads';

export const storeGetAllPositionSchedulingRules = (
  page: number = 1,
  status: number = 1,
  searchTerm: string = ''
) => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());
    const resp = await getAllPositionSchedulingRulesService(page, status, searchTerm);

    console.log('frutaaaa ', resp);
    if (resp?.ok) {
      await dispatch(setPositionSchedulingRules(resp.data));
      await dispatch(setPositionForSelect(resp.data.positions));
      await dispatch(setGlobalRules(resp.data.globalRules || null));
    }
    dispatch(unCheckingPreload());
    return resp;
  };
};

export const storeCreatePositionSchedulingRule = (data: any) => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());
    const resp = await createPositionSchedulingRuleService(data);
    dispatch(unCheckingPreload());
    return resp;
  };
};

export const storeUpdatePositionSchedulingRule = (id: string, data: any) => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());
    const resp = await updatePositionSchedulingRuleService(id, data);
    dispatch(unCheckingPreload());
    return resp;
  };
};

export const storeGetPositionSchedulingRuleById = (id: string) => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());
    const resp = await getPositionSchedulingRuleByIdService(id);
    if (resp?.ok) {
      dispatch(setPositionSchedulingRule(resp.data));
    }
    dispatch(unCheckingPreload());
    return resp;
  };
};

export const storeDeletePositionSchedulingRule = (
  id: string,
  searchTerm: string = '',
  page: number = 1
) => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());
    const resp = await deletePositionSchedulingRuleService(id);
    if (resp?.ok) {
      dispatch(storeGetAllPositionSchedulingRules(page, 0, searchTerm));
    }
    dispatch(unCheckingPreload());
    return resp;
  };
};

export const storeRestorePositionSchedulingRule = (
  id: string,
  searchTerm: string = '',
  page: number = 1
) => {
  return async (dispatch: any) => {
    dispatch(checkingPreload());
    const resp = await restorePositionSchedulingRuleService(id);
    if (resp?.ok) {
      dispatch(storeGetAllPositionSchedulingRules(page, 1, searchTerm));
    }
    dispatch(unCheckingPreload());
    return resp;
  };
};
